// extracted by mini-css-extract-plugin
export default {"logo":"similar-to-youyLuRGe","placeholder":"similar-to-youmsqucs","logo__image":"similar-to-youW9avJr"};